// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__3ZDhE","menu":"tab_menu__3cK9n","selectedMenu":"tab_selectedMenu__K5Sd6"};